import propEq from 'ramda/src/propEq'
import equals from 'ramda/src/equals'
import {
	ADMIN_CAMPAIGN_MANAGEMENT_MODAL_MODULE_ID,
	DROP_ADMIN_LIST_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import { auditEnum, statusEnum } from 'root/src/shared/constants/enums'
import {
	dropEventActivateMethodsEnum,
	dropEventStatusEnum,
} from 'root/src/shared/constants/dropEvent'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import {
	GET_DROP_EVENTS,
	DROP_ADMIN_AUDIT,
	DROP_ACTIVATE_EVENT,
	CHANGE_CAMPAIGN_STATUS,
	DROP_EDIT_EVENT,
} from 'root/src/shared/descriptions/endpoints/endpointIds'
import wait from 'root/src/shared/util/wait'
import { adminKey } from 'root/src/shared/constants/keys'
import moment from 'moment'
import orEmpty from 'root/src/shared/util/orEmpty'

const handleError = (res) => {
	if (res.statusCode !== 200) {
		throw res.error
	}
}

export default {
	[ADMIN_CAMPAIGN_MANAGEMENT_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalContent: {
			buttonRows: [
				[
					{
						buttonText: 'Enable',
						onClickFn: async ({ dropEvent, getState, dispatch }) => {
							const { id, brand } = dropEvent || {}
							handleError(
								await apiRequest(CHANGE_CAMPAIGN_STATUS, {
									action: statusEnum.ENABLE,
									dropEventId: id,
									brandId: brand.id,
								})(dispatch, getState),
							)
							await wait(2000)
							await apiRequest(
								GET_DROP_EVENTS,
								{
									section: adminKey,
									pageItemLength: 20,
								},
								true,
								DROP_ADMIN_LIST_MODULE_ID,
							)(dispatch, getState)
						},
						disabledFn: (dropEvent) => {
							if (propEq('approved', false, dropEvent)) {
								return true
							}
							return propEq('status', dropEventStatusEnum.ACTIVE, dropEvent)
						},
					},
					{
						buttonText: 'Disable',
						onClickFn: async ({ dropEvent, getState, dispatch }) => {
							const { id, brand } = dropEvent || {}
							await apiRequest(CHANGE_CAMPAIGN_STATUS, {
								action: statusEnum.DISABLE,
								dropEventId: id,
								brandId: brand.id,
							})(dispatch, getState)
							await wait(2000)
							await apiRequest(
								GET_DROP_EVENTS,
								{
									section: adminKey,
									pageItemLength: 20,
								},
								true,
								DROP_ADMIN_LIST_MODULE_ID,
							)(dispatch, getState)
						},
						disabledFn: (dropEvent) => {
							if (!dropEvent.approved) {
								return true
							}
							return !propEq('status', dropEventStatusEnum.ACTIVE, dropEvent)
						},
					},
				],
			],
			submitButton: {
				buttonText: 'Submit',
				onClickFn: async ({
					dropEvent,
					dispatch,
					date,
					originalPointAwardingStatus,
					awardPoints,
					isCommunityDrop,
					originalIsCommunityDrop,
					approveCampaign,
					activateInvoice,
					disableUserHasGame,
					originalDisableUserHasGame,
				}) => {
					const dateModification = !equals(date, dropEvent.expirationDate)
					const pointsAwardingStatusChanged = originalPointAwardingStatus !== awardPoints
					const isCommunityDropChanged =	originalIsCommunityDrop !== isCommunityDrop
					const disableUserHasGameChanged =	originalDisableUserHasGame !== disableUserHasGame
					if (moment().isSame(date, 'day')) {
						await dispatch(
							apiRequest(CHANGE_CAMPAIGN_STATUS, {
								action: statusEnum.DISABLE,
								dropEventId: dropEvent.id,
								brandId: dropEvent.brand.id,
							}),
						)
					}
					if (
						dateModification
							|| pointsAwardingStatusChanged
							|| isCommunityDropChanged
							|| disableUserHasGameChanged
					) {
						await dispatch(apiRequest(DROP_EDIT_EVENT, {
							dropEventPayload: {
								campaignName: dropEvent.campaignName,
								isCommunityDrop,
								id: dropEvent.id,
								...orEmpty(dateModification, {
									expirationDate: moment.utc(date),
								}),
								...orEmpty(pointsAwardingStatusChanged, { awardPoints }),
								...orEmpty(isCommunityDropChanged, { isCommunityDrop }),
								...orEmpty(disableUserHasGameChanged, { disableUserHasGame }),
							},
						}))
					}
					if (activateInvoice) {
						const res = await dispatch(apiRequest(DROP_ACTIVATE_EVENT, {
							id: dropEvent.id,
							method: dropEventActivateMethodsEnum.INVOICE,
						}))
						handleError(res)
					}
					if (propEq('approved', false, dropEvent) && approveCampaign) {
						const res = await dispatch(apiRequest(DROP_ADMIN_AUDIT, {
							audit: auditEnum.ACTIVATE,
							id: dropEvent.id,
						}))
						handleError(res)
					}

					await wait(2000)
					await dispatch(apiRequest(
						GET_DROP_EVENTS,
						{
							section: adminKey,
							pageItemLength: 20,
						},
						true,
						DROP_ADMIN_LIST_MODULE_ID,
					))
				},
			},
		},
	},
}
